import Vue from 'vue';
import Vuex from 'vuex';
import PartnerGroupStore from '@/admin/modules/CustomerGroup/_store/store';
import PaymentTypeStore from '@/admin/modules/PaymentType/_store/store';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    PartnerGroupStore,
    PaymentTypeStore,
  },
  state: {

  },
  mutations: {

  },
  actions: {

  },
});
